import type { Virtualizer } from '@tanstack/react-virtual';
import { createContext } from 'react';

type TRowVirtualizer = Virtualizer<HTMLDivElement, Element> | null;

export const CardVirtualizationContext = createContext<TRowVirtualizer>(null);
